// Dispara o evento Lead do Meta antes de mandar a usuária pro app.
// Centraliza o tracking: muda aqui, muda em todos os botões.
const APP_URL = 'https://app.menoease.com.br';

// Recupera as UTMs salvas e monta a query string para repassar ao app.
// Necessário porque localStorage não é compartilhado entre domínios
// (menoease.com.br -> app.menoease.com.br), então a atribuição viaja pela URL.
function buildAppUrlWithUtms() {
  try {
    const raw = localStorage.getItem('me_utms');
    if (!raw) return APP_URL;
    const utms = JSON.parse(raw);
    const params = new URLSearchParams();
    Object.keys(utms).forEach(function (k) {
      if (utms[k]) params.append(k, utms[k]);
    });
    const qs = params.toString();
    return qs ? APP_URL + '?' + qs : APP_URL;
  } catch (e) {
    return APP_URL;
  }
}

export function goToApp(source) {
  try {
    if (window.fbq) {
      window.fbq('track', 'Lead', source ? { content_name: source } : {});
    }
  } catch (e) {}
  var destination = buildAppUrlWithUtms();
  // 250ms garante o disparo do pixel antes da navegação
  setTimeout(function () { window.location.href = destination; }, 250);
}
